import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.reducers';
import { codigoInstalacion } from 'app/models/global.models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StartGuard implements CanActivate {

  constructor(
    private router: Router,
    private store: Store<AppState>,
  ) { }

  canActivate(): Observable<boolean> {
    return this.store.select(state => state.configuracion.codigosInstalacion)
      .pipe(
        map((codigosInstalacion: Array<codigoInstalacion>) => {
          if (!codigosInstalacion || codigosInstalacion.length === 0) {
            this.router.navigate(['installation']);
            return false;
          } else {
            this.router.navigate(['sign-in']);
            return false;
          }
        })
      );
  }
}
